import { Component, inject, Inject } from '@angular/core';

import { EpdEditSectionComponent } from '../epd-edit-section/epd-edit-section.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonComponent } from '@mds/ui';
import { EpdV2Service } from '../../services/epd-v2.service';
import { ToastrService } from '@services/toaster.service';

@Component({
  selector: 'app-epd-export-modal',
  templateUrl: './epd-export-modal.component.html',
  styleUrls: ['./epd-export-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent, EpdEditSectionComponent],
  providers: [EpdV2Service, ToastrService]
})
export class EpdExportModalComponent {
  protected form: any;
  protected values: any;
  protected payload = null;
  protected epdV2Service = inject(EpdV2Service);
  protected toastrService = inject(ToastrService);
  private initiateDownload = false;

  get exportButtonLabel() {
    return this.payload ? 'Save & Export' : 'Export';
  }

  constructor(@Inject(MAT_DIALOG_DATA) protected data: any) {}

  onModelChanged(event) {
    if (!this.values) this.values = event.value;
    else {
      const updated = {};
      Object.entries(this.values).forEach(([k, v]) => {
        if (v !== event.value[k]) {
          updated[k] = event.value[k];
        }
      });

      if (Object.keys(updated).length) {
        this.payload = updated;
      }
    }
    this.form = event;
  }

  onSave() {
    if (!this.form?.valid) return;

    this.epdV2Service.submitData(this.data.rid, this.payload).subscribe((response) => {
      this.payload = null;
      if (this.initiateDownload) this.onExport();
      this.initiateDownload = false;
    });
  }

  onExport() {
    if (this.payload) {
      this.initiateDownload = true;
      this.onSave();
      return;
    }

    this.epdV2Service.downloadAdditionalExports(this.data.url).subscribe(
      (response) => {
        const blob = response.body;
        const contentDisposition = response.headers.get('content-disposition');
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');

        anchor.href = url;
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=([^;\n]*)/);
          if (match && match[1]) {
            anchor.download = decodeURIComponent(match[1].replace(/['"]/g, '').trim());
          }
        } else anchor.setAttribute('download', '');
        anchor.click();
        setTimeout(() => {
          anchor.remove();
          URL.revokeObjectURL(url);
        }, 100);
      },
      async (error) => {
        if (error?.status === 400 && error?.error instanceof Blob && error.error.type === 'application/json') {
          try {
            const text = await error.error.text();
            const json = JSON.parse(text);
            if (json.message) {
              this.toastrService.show(json.message, 5000);
              return;
            }
          } catch {
            //
          }
        }
        this.toastrService.show('Download failed', 3000);
      }
    );
  }
}
